import React, { useContext, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Button } from 'modules';
import FormModal from './FormModal';
import SubmitModal from './SubmitModal';
import PartnerForm from './PartnerForm';
import { WebsocketActions, WebsocketContext } from 'services/WebsocketContext';
import { selectConsultantAccess } from 'stores/onlineForm/onlineForm';

interface PartnerProps {
  isViewMode: boolean;
  form: GQL.IContractOnlineForm;
  contract: GQL.IContract;
  values: GQL.ITClient2 | null;
  onChange: (e: React.ChangeEvent) => void;
}

const Partner = ({ ...props }: PartnerProps) => {
  const wsContext = useContext(WebsocketContext);
  const isConsultantAccess = useSelector(selectConsultantAccess);

  // modal s formulářem s daty partnera
  const [showFormModal, setShowFormModal] = useState(false);
  // malé konfirmační okno pro potvrzení zda přidat či nepřidat partnera
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const toggleShowConfirmModal = () => {
    setShowConfirmModal(!showConfirmModal);
  };

  const handleShowFormModal = () => {
    // skrytí konfirmace, a zobrazení modalu
    setShowConfirmModal(false);
    setShowFormModal(true);
    // refresh smlouvy
    wsContext?.send({
      action: WebsocketActions.REFRESH_CONTRACT_STATE,
    });
    // zobrazení modalu s formulářem partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_FORM_OPEN,
      value: true,
    });
  };

  const handleCloseFormModal = () => {
    // skrytí modalu s formularem
    setShowFormModal(false);
    // zobrazení modalu s formulářem partnera
    wsContext?.send({
      action: WebsocketActions.CONTRACT_PARTNER_FORM_OPEN,
      value: false,
    });
  };

  useEffect(() => {
    wsContext?.ws?.on(WebsocketActions.CONTRACT_PARTNER_FORM_OPEN, setShowFormModal);
    return () => {
      wsContext?.ws?.off(WebsocketActions.CONTRACT_PARTNER_FORM_OPEN);
    };
    // eslint-disable-next-line
  }, []);

  // je zadán partner, a modal s partnerem byl dokončen
  if (!!props.contract.client2 && props.values?.finished === true) {
    return (
      <>
        <hr />
        <PartnerForm isViewMode={props.isViewMode} values={props.values} onChange={props.onChange} />
      </>
    );
  }

  return (
    <>
      {isConsultantAccess && (
        <>
          <hr />
          <Row>
            <Col className="text-right">
              <Button type="button" disabled={props.isViewMode} variant="primary" onClick={toggleShowConfirmModal}>
                Pridať manžela / manželku
              </Button>
            </Col>
          </Row>
        </>
      )}
      {showFormModal && props.contract.id_klient_2 && (
        <FormModal {...props} client2Id={props.contract.id_klient_2} onClose={handleCloseFormModal} />
      )}
      {showConfirmModal && !props.isViewMode && (
        <SubmitModal contract={props.contract} onSubmit={handleShowFormModal} onClose={toggleShowConfirmModal} />
      )}
    </>
  );
};

export default Partner;
